export enum ResponseCodes {
    OK = 200,
    ABORT_METAMASK_SIGNING = 1021,
    CHECKOUT_NOT_ON_ALLOWLIST_MAIL = 1104,
    CHECKOUT_NOT_ON_ALLOWLIST_MAIL_AND_WALLET = 1105,
    CHECKOUT_MAX_INSTANCES_BOUGHT = 1106
}